import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

const TrainTravelClassDropdown = (props: DropdownWithoutOptionsProps<server.dto.TrainTravelClass, server.dto.TrainTravelClasses>) => {
  return <BaseReactSelectDropdown
    excludeKeys={["unknown"]}
    options={serverReference.trainTravelClasses}
    getLabel={p => p.text}
    getValue={(t) => t.value}
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    config={{
      ...props.config,
      isClearable: true,
    }}
  />;
};

export default TrainTravelClassDropdown;